// extracted by mini-css-extract-plugin
export default {"header":"Career_header__BttI3","header_img":"Career_header_img__xYqlI","h2":"Career_h2__6ONpg","text":"Career_text__4BMie"};